/* NEVEOR Night Images — load only when AuraDark is on and card is nearby */
(() => {
  'use strict';
  const night = () => document.documentElement.getAttribute('data-darkpilot-mode') === 'dark';
  const known = new Set();
  let observer;
  const near = el => {
    const b = el.getBoundingClientRect();
    return b.bottom >= -300 && b.top <= innerHeight + 300;
  };
  function load(img) {
    if (img.dataset.nvState) return;
    img.dataset.nvState = 'loading';
    const frame = img.closest('.nv-night-frame');
    const ready = () => {
      if (frame && img.naturalWidth) {
        frame.classList.add('nv-ready');
        img.dataset.nvState = 'ready';
      }
    };
    img.addEventListener('load', () => {
      img.decode ? img.decode().then(ready).catch(ready) : ready();
    }, {once: true});
    img.addEventListener('error', () => { img.dataset.nvState = 'error'; }, {once: true});
    img.sizes = img.closest('.nv-product-frame') ? '(max-width: 767px) 100vw, 60vw' : '(max-width: 767px) 100vw, 33vw';
    img.srcset = img.dataset.nvNightSrcset;
    img.src = img.dataset.nvNightSrc;
    if (img.complete && img.naturalWidth) ready();
  }
  function collect(node) {
    const els = [];
    if (node.matches && node.matches('.nv-night-image')) els.push(node);
    if (node.querySelectorAll) els.push(...node.querySelectorAll('.nv-night-image'));
    for (const img of els) {
      if (known.has(img)) continue;
      known.add(img);
      observer.observe(img);
      if (night() && near(img)) load(img);
    }
  }
  function onMode() {
    if (!night()) return;
    for (const img of known) {
      if (!img.isConnected) { known.delete(img); continue; }
      if (near(img)) load(img);
    }
  }
  function init() {
    const grid = document.getElementById('result-product-grid');
    const gallery = document.querySelector('.main-product-images');
    const recommendedSections = document.querySelectorAll('body.nv-product-page .section-featured-collection');
    if (!grid && !gallery && !recommendedSections.length) return;
    observer = new IntersectionObserver(entries => {
      if (night()) for (const e of entries) if (e.isIntersecting) load(e.target);
    }, { rootMargin: '300px 0px' });
    if (grid) collect(grid);
    if (gallery) collect(gallery);
    for (const recommended of recommendedSections) collect(recommended);
    const popup = document.getElementById('product-media-popup');
    if (popup) collect(popup);
    new MutationObserver(onMode).observe(document.documentElement, {
      attributes: true, attributeFilter: ['data-darkpilot-mode']
    });
    const main = document.body;
    if (main) new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) {
        if (node.nodeType === 1) collect(node);
      }
    }).observe(main, {childList: true, subtree: true});
    onMode();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
